import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import type { ManagerAvgTimeToKp } from './types'

function formatDate(iso: string): string {
  const d = new Date(iso)
  return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}`
}

export function TimeToKpChart({ data }: { data: ManagerAvgTimeToKp }) {
  const up = data.deltaDays !== null && data.deltaDays > 0
  // Рост времени до КП — плохо (красный), падение — хорошо (зелёный)
  const deltaCls =
    data.deltaDays === null
      ? 'text-gray-400'
      : data.deltaDays > 0
        ? 'text-red-600'
        : data.deltaDays < 0
          ? 'text-emerald-600'
          : 'text-gray-400'

  const chartData = data.timeline.map((p) => ({
    date: formatDate(p.date),
    value: p.value,
  }))

  return (
    <div className="bg-white rounded-2xl border border-gray-200 p-4 h-full flex flex-col">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <div className="text-sm text-gray-500">Время до КП (среднее)</div>
          <div className="text-2xl font-bold text-gray-900 mt-1">
            {data.currentDays === null ? '—' : `${data.currentDays} д.`}
          </div>
        </div>
        {data.deltaDays !== null && data.deltaDays !== 0 && (
          <span className={`text-xs font-medium ${deltaCls}`}>
            {up ? '↑' : '↓'} {Math.abs(data.deltaDays)} д. vs прошлый период
          </span>
        )}
      </div>

      <div className="flex-1 min-h-[160px] mt-2">
        <ResponsiveContainer width="100%" height="100%" minHeight={120}>
          <LineChart data={chartData} margin={{ top: 8, right: 8, left: 0, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 11, fill: '#6b7280' }}
              axisLine={{ stroke: '#e5e7eb' }}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 11, fill: '#6b7280' }}
              axisLine={{ stroke: '#e5e7eb' }}
              tickLine={false}
              tickFormatter={(v: number) => `${v} д.`}
            />
            <Tooltip
              formatter={(v) => [v === null ? '—' : `${v} д.`, 'Время до КП']}
              contentStyle={{
                borderRadius: 8,
                border: '1px solid #e5e7eb',
                fontSize: 12,
              }}
            />
            <Line
              type="monotone"
              dataKey="value"
              stroke="#3b82f6"
              strokeWidth={2}
              dot={{ r: 3, fill: '#3b82f6' }}
              connectNulls
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
